import { api } from "../../axios";
export const actions = {
    getDraftJournalEntries(context, {campusId}) {
        return api.get(`JournalEntry/Draft/${campusId}`);
    },
    getPostedJournalEntries(context, data) {
        return api.post(`JournalEntry/Posted/${data.campusId}`, data);
    },
    createJournalEntry(context, data) {
        return api.post(`JournalEntry/Add`, data);
    },
    getSingleJournalEntry(context, id) {
        return api.get(`JournalEntry/${id}`);
    },
    updateJournalEntry(context, data) {
        return api.put(`JournalEntry/${data.id}`, data);
    },
    deleteJournalEntry(context, id) {
        return api.delete(`JournalEntry/${id}`);
    },
    postJournalEntry(context, id) {
        return api.post(`JournalEntry/Post/${id}`);
    }
}